import * as React from 'react';
import aos from '@src/utils/aos';
import wrapStore from '@src/utils/wrap-store';
import CmsRichText from '../cms-rich-text';
import MatchRewardsStore from './store';
import styles from './index.less';

const REGIONS = [
  {
    id: 'sword',
    title: '剑世区',
    contentKey: 'swordRewardHtml',
    benefits: {
      exclusive: {
        title: '冠军专属',
        contentKey: 'swordChampionExclusiveHtml'
      },
      mount: {
        title: '稀有坐骑',
        contentKey: 'swordRareMountHtml'
      },
      extra: {
        title: '定制同伴',
        contentKey: 'swordCustomPartnerHtml'
      }
    }
  },
  {
    id: 'green',
    title: '绿色区',
    contentKey: 'greenRewardHtml',
    benefits: {
      exclusive: {
        title: '冠军专属',
        contentKey: 'greenChampionExclusiveHtml'
      },
      mount: {
        title: '属性坐骑',
        contentKey: 'greenRareMountHtml'
      },
      extra: {
        title: '丰厚奖励',
        contentKey: 'greenExtraRewardHtml'
      }
    }
  }
];

const classNames = (...names) => names.filter(Boolean).join(' ');

const BenefitPanel = ({ benefits, content }) => (
  <div className={styles.benefitVisual}>
    <div className={classNames(styles.benefitBox, styles.exclusiveBox)}>
      <strong className={styles.benefitTitle}>{benefits.exclusive.title}</strong>
      <CmsRichText html={content[benefits.exclusive.contentKey]} />
    </div>
    <div className={classNames(styles.benefitBox, styles.mountBox)}>
      <strong className={styles.benefitTitle}>{benefits.mount.title}</strong>
      <CmsRichText html={content[benefits.mount.contentKey]} />
    </div>
    <div className={classNames(styles.benefitBox, styles.extraBox)}>
      <strong className={styles.benefitTitle}>{benefits.extra.title}</strong>
      <CmsRichText html={content[benefits.extra.contentKey]} />
    </div>
  </div>
);

const MatchRewards = ({ content, store }) => {
  store.use();
  const tabRefs = React.useRef([]);

  const selectRegionTab = index => {
    const region = REGIONS[index];
    store.setActiveRegion(region.id);

    if (tabRefs.current[index]) {
      tabRefs.current[index].focus();
    }
  };

  const handleRegionTabKeyDown = (event, index) => {
    let nextIndex;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (index + 1) % REGIONS.length;
        break;
      case 'ArrowLeft':
        nextIndex = (index - 1 + REGIONS.length) % REGIONS.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = REGIONS.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    selectRegionTab(nextIndex);
  };

  return (
    <div className={styles.root}>
      <section className={`${styles.contentSession} ${styles.introSession}`} aria-label="比赛奖励领取说明">
        <div className={styles.content}>
          <div className={styles.intro} data-aos-duration="600" data-aos-once="true" {...aos.FADE_RIGHT()}>
            <CmsRichText className={styles.richText} html={content.rewardDescriptionHtml} />
          </div>
        </div>
      </section>
      <section className={`${styles.contentSession} ${styles.rewardsSession}`} aria-label="比赛奖励内容">
        <div className={styles.content}>
          <div className={styles.rewards} data-aos-duration="600" data-aos-once="true" {...aos.FADE_UP()}>
            <div className={styles.regionTabs} role="tablist" aria-label="比赛奖励区服">
              {REGIONS.map((region, index) => {
                const isActive = store.activeRegionId === region.id;
                return (
                  <button
                    type="button"
                    id={`match-rewards-tab-${region.id}`}
                    tabIndex={isActive ? 0 : -1}
                    className={classNames(styles.regionTab, isActive && styles.activeRegionTab)}
                    role="tab"
                    aria-selected={isActive}
                    ref={element => {
                      tabRefs.current[index] = element;
                    }}
                    aria-controls={`match-rewards-panel-${region.id}`}
                    onKeyDown={event => handleRegionTabKeyDown(event, index)}
                    data-region-id={region.id}
                    key={region.id}
                    onClick={() => store.setActiveRegion(region.id)}
                  >
                    {region.title}
                  </button>
                );
              })}
            </div>
            {REGIONS.map(region => (
              <div
                aria-labelledby={`match-rewards-tab-${region.id}`}
                className={styles.regionPanel}
                id={`match-rewards-panel-${region.id}`}
                role="tabpanel"
                aria-label={`${region.title}比赛奖励`}
                hidden={store.activeRegionId !== region.id}
                key={region.id}
              >
                <BenefitPanel benefits={region.benefits} content={content} />
                <CmsRichText className={styles.richText} html={content[region.contentKey]} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

MatchRewards.defaultProps = {
  content: {}
};

export default wrapStore(MatchRewards, MatchRewardsStore);
